"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addBeaconDelegate = addBeaconDelegate;
exports.configureBeacon = configureBeacon;
exports.flushBeaconData = flushBeaconData;
exports.resetBeacon = resetBeacon;
exports.sendBeacon = sendBeacon;
exports.sendBeaconWhenReady = sendBeaconWhenReady;

var _variables2 = require("./variables");

var _getKeys = _interopRequireDefault(require("./utilities/getKeys"));

var _requestIdleCallback = _interopRequireDefault(require("./utilities/requestIdleCallback"));

var beaconOptions = {};
/**
 * Holds whether a beacon request has been queued for delivery.
 */

var beaconQueued = false;
/**
 * A collection of variables queued for beaconing.
 */

var beaconQueue = [];
var beaconDelegates = [];

function configureBeacon(options) {
  beaconOptions = options;
}

function addBeaconDelegate(delegate) {
  beaconDelegates.push(delegate);
}
/**
 * Useful in tests to teardown beacon, otherwise should never be used.
 */


function resetBeacon() {
  beaconOptions = {};
  beaconQueue = [];
  beaconDelegates = [];
}

function beaconShouldSendData() {
  return beaconDelegates.every(function (delegate) {
    return typeof delegate.beaconShouldSendData !== 'function' || delegate.beaconShouldSendData();
  });
}

function beaconDidSendData(variables) {
  beaconDelegates.forEach(function (delegate) {
    if (typeof delegate.beaconDidSendData === 'function') {
      delegate.beaconDidSendData.call(delegate, variables);
    }
  });
}

function beaconWillSendData(variables) {
  beaconDelegates.forEach(function (delegate) {
    if (typeof delegate.beaconWillSendData === 'function') {
      delegate.beaconWillSendData.call(delegate, variables);
    }
  });
}

function sendBeaconData(variables) {
  var _beaconOptions = beaconOptions,
      _beaconOptions$report = _beaconOptions.reporters,
      reporters = _beaconOptions$report === void 0 ? [] : _beaconOptions$report;
  return reporters.every(function (reporter) {
    return reporter(variables);
  });
}

function flushBeaconQueue() {
  if (beaconQueue.length > 0) {
    var _variables = beaconQueue.shift();

    if (_variables != null) {
      // eslint-disable-next-line no-use-before-define
      sendBeaconWhenReady(_variables);
    }
  }
}
/**
 * Sends beacon with all queued beacon data.
 *
 * This function should be called to ensure any queued beacon data is flushed.
 * Useful to send the last beacon before the page is terminated or any time a
 * new beacon is about to be constructed.
 */


function flushBeaconData() {
  if (!beaconQueued) {
    return false;
  }

  beaconQueued = false; // At this point a plugin is ready to send the beacon, however we send the
  // beacon only if all plugins have finished doing what they wanted to do.

  if (!beaconShouldSendData()) {
    return false;
  } // Sanity test that the browser is still available (and not shutting down)


  if (window == null || window.Image == null || window.navigator == null) {
    return false;
  }

  beaconWillSendData((0, _variables2.getVariables)());
  var variables = (0, _variables2.cloneVariables)();

  if ((0, _getKeys.default)(variables).length === 0) {
    return false;
  }

  if (!sendBeaconData(variables)) {
    return false;
  }

  (0, _variables2.removeSingleBeaconVariables)();
  beaconDidSendData(variables);
  flushBeaconQueue();
  return true;
}
/**
 * Request to send beacon with all queued beacon data.
 *
 * This request may be ignored.
 *
 * This function should be called any time a plugin completes its task so the
 * beacon is sent.
 *
 * The actual beaconing is handled in `flushBeaconData` after a short delay.
 * If other calls to `sendBeacon` happen before `flushBeaconData` is called,
 * those calls will be discarded, so it's OK to call this function in quick
 * succession.
 */


function sendBeacon() {
  if (beaconQueued) {
    return false;
  }

  beaconQueued = true;
  (0, _requestIdleCallback.default)(flushBeaconData);
  return true;
}
/**
 * Sends a beacon when the beacon queue is empty.
 */


function sendBeaconWhenReady(variables) {
  if (beaconQueued) {
    beaconQueue.push(variables);
    return;
  }

  (0, _getKeys.default)(variables).forEach(function (key) {
    (0, _variables2.addVariable)(key, variables[key], true);
  });
  sendBeacon();
}